import { render, staticRenderFns } from "./CompraSuc.vue?vue&type=template&id=319ae072&"
import script from "./CompraSuc.vue?vue&type=script&lang=js&"
export * from "./CompraSuc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports